// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"8366":"1fdb954b","9086":"c7d2b47f","9474":"017446fc"}[chunkId] + ".css";
};